/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { PaymentMethodResourceService, PaymentMethodVO } from '@well/company-libs/payment-method/shell-api';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Injectable({providedIn: "root"})
export class PaymentMethodPendingStepService{

  constructor(private paymentMethodResourceService: PaymentMethodResourceService) {
  }

  getCurrentPaymentMethodVO(): Observable<JsonApiResource<PaymentMethodVO, any>>{
    return this.paymentMethodResourceService.getCurrentPaymentMethodVO();
  }

}
